import { SagaActionProps } from 'APP/Models/Actions'
import { call, put } from 'typed-redux-saga'
import { ResultsResponse } from '@dialogue/smartsearch'

import { semanticSearchActions } from './slice'
import { SemanticSearchRequest } from './types'
import { getSearchResults } from '../utils/smartsearch'
import Analytics from 'APP/Services/Analytics'

export function* runSemanticSearch({ payload }: SagaActionProps<SemanticSearchRequest>) {
  try {
    yield call(Analytics.trackEvent, 'semantic_search_query', {
      query: payload.query,
      source: payload.source,
    })

    const results: ResultsResponse = yield* call(getSearchResults, payload.source, payload.query)
    yield put(semanticSearchActions.runSemanticSearchSuccess(results.results as string[]))
  } catch (e) {
    yield put(semanticSearchActions.runSemanticSearchFailure({ error: e as Error }))
  }
}
